<template>
  <div>

    <p>
      I den här lektionen får du lära dig om sociala medier. Hur sprids information och vad är det som avgör vad just du får se i ditt flöde? 
    </p>

  </div>
</template>

<script>

//Exercises

export default {
  components: {
  },
  data () {
    return {
      'name': 'Sociala medier',
      'route': 'socialamedier',
      excercises: {
      }
    }
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/learn/lessons/data/SocialMedia.vue